<div class="modal-header">
  <h5 class="modal-title">Edit Rulebook</h5>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>

<div class="modal-body" style="overflow: scroll; max-height: 550px;">
  <form>
    <div class="form-group row mt-3" *ngIf="rulebookData.insertedRow == 0">
      <div class="col-lg-4 col-md-4">
        <label class="control-label fw">Regulator</label>
        <input type="text" [(ngModel)]="rulebookData.regulator" class="form-control form-control-sm" name="regulator" />
      </div>
      <div class="col-lg-4 col-md-4">
        <label class="control-label fw">Effective Date</label>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="picker" (click)="picker.open()" class="form-control form-control-sm"
            name="effectiveDate" [(ngModel)]="rulebookData.effectiveDate" readonly>
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
          </div>
        </div>
        <mat-datepicker #picker></mat-datepicker>
      </div>
      <div class="col-lg-4 col-md-4">
        <label class="control-label fw">Title</label>
        <input type="text" [(ngModel)]="rulebookData.title" class="form-control form-control-sm" name="title" />
      </div>
    </div>

    <div class="form-group row mt-3" *ngIf="rulebookData.insertedRow == 0">
      <div class="col-lg-6 col-md-6">
        <label class="control-label fw">Title 1</label>
        <textarea type="text" [(ngModel)]="rulebookData.title1" class="form-control form-control-sm height-100"
          name="title1"></textarea>
      </div>
      <div class="col-lg-6 col-md-6">
        <label class="control-label fw">Title 2</label>
        <textarea type="text" [(ngModel)]="rulebookData.title2" class="form-control form-control-sm height-100"
          name="title2"></textarea>
      </div>
    </div>

    <div class="form-group row mt-3" *ngIf="rulebookData.insertedRow == 0">
      <div class="col-lg-6 col-md-6">
        <label class="control-label fw">Title 3</label>
        <textarea type="text" [(ngModel)]="rulebookData.title3" class="form-control form-control-sm height-100"
          name="title3"></textarea>
      </div>
      <div class="col-lg-6 col-md-6">
        <label class="control-label fw">Title 4</label>
        <textarea type="text" [(ngModel)]="rulebookData.title4" class="form-control form-control-sm height-100"
          name="title4"></textarea>
      </div>
    </div>

    <div class="form-group row mt-3">
      <div class="col-lg-6 col-md-6">
        <label class="control-label fw">Title 5</label>
        <input type="text" [(ngModel)]="rulebookData.title5" class="form-control form-control-sm" name="title5" />
      </div>
      <div class="col-lg-6 col-md-6">
        <label class="control-label fw">Rule ID</label>
        <input type="text" [(ngModel)]="rulebookData.ruleId" class="form-control form-control-sm" name="ruleId" />
      </div>
    </div>

    <div class="form-group row mt-3">
      <div class="col-lg-12 col-md-12">
        <label class="control-label fw">Regulator Rule Full Requirement</label>
        <textarea type="text" [(ngModel)]="rulebookData.regulatorRuleFullRequirement"
          class="form-control form-control-sm height-100" name="rulebookDataFullRequirement"></textarea>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="submit" (click)="onSubmit()" class="btn btn-sm bg-g-green pull-right mt-3" [mat-dialog-close]="false">
    Update
  </button>
</div>